const LOCAL_STORAGE_CHECKOUT_RESTORE_VALUES = "real-commerce-checkout-restore-values";
export { LOCAL_STORAGE_CHECKOUT_RESTORE_VALUES };
